// import { Spinner } from "react-bootstrap"
import { CircularProgress } from "@mui/material"
import "./ChatLoader.scss"

const ChatLoader = () => {
    return (
        <div className="chat-loader-wrapper">
            {/* <Spinner size="sm" animation="grow" variant="secondary" className="offset-spinner delay-1" />
            <Spinner size="sm" animation="grow" variant="secondary" className="offset-spinner delay-2" />
            <Spinner size="sm" animation="grow" variant="secondary" className="offset-spinner delay-3" /> */}
            <CircularProgress />
        </div>
    )
}

export default ChatLoader